/* eslint-disable max-len */
/* eslint-disable object-curly-newline */
export type RouteId =
  'homepage'
  | 'account' | 'login' | 'logout' | 'register' | 'confirm' | 'forgot-password'
  | 'project-settings'
  | 'departments' | 'department-add' | 'department-detail' | 'department-update'
  | 'employees' | 'employee-add' | 'employee-detail' | 'employee-update'
  | 'applications' | 'application-detail'
  | 'devices' | 'device-detail' | 'vendors' | 'vendor-detail' | 'vendor-add' | 'vendor-update'
  | 'licenses' | 'license-detail' | 'license-add' | 'license-update'
  | 'integrations';

export interface RouteItem {
  id: RouteId;
  path: string;
  authRequired: boolean;
  label: string;
  parent?: RouteId;
}

export const Routes: RouteItem[] = [
  { id: 'homepage', path: '/', authRequired: true, label: 'Overview' },

  // auth
  { id: 'login', path: '/login', authRequired: false, label: 'Login' },
  { id: 'logout', path: '/logout', authRequired: true, label: 'Logout' },
  { id: 'register', path: '/register', authRequired: false, label: 'Register' },
  { id: 'confirm', path: '/confirm', authRequired: false, label: 'Confirm' },
  { id: 'forgot-password', path: '/forgot-password', authRequired: false, label: 'Forgot Password' },

  // account
  { id: 'account', path: '/account/:activeTab', authRequired: true, label: 'Account' },

  // project
  { id: 'project-settings', path: '/project-settings/:activeTab', authRequired: true, label: 'Project Settings' },

  // departments
  { id: 'departments', path: '/departments', authRequired: true, label: 'Departments' },
  { id: 'department-add', path: '/add-department', authRequired: true, parent: 'departments', label: 'Add Department' },
  { id: 'department-detail', path: '/department-detail/:departmentId', authRequired: true, parent: 'departments', label: 'Department Detail' },
  { id: 'department-update', path: '/department-update/:departmentId/:activeTab', authRequired: true, parent: 'department-detail', label: 'Department Update' },

  // employees
  { id: 'employees', path: '/employees', authRequired: true, label: 'Employees' },
  { id: 'employee-add', path: '/add-employee', authRequired: true, parent: 'employees', label: 'Add Employee' },
  { id: 'employee-detail', path: '/employee-detail/:employeeId', authRequired: true, parent: 'employees', label: 'Employee Detail' },
  { id: 'employee-update', path: '/employee-update/:employeeId/:activeTab', authRequired: true, parent: 'employee-detail', label: 'Employee Update' },

  // applications
  { id: 'applications', path: '/applications', authRequired: true, label: 'Applications' },
  { id: 'application-detail', path: '/application-detail/:applicationId', authRequired: true, parent: 'applications', label: 'Application Usage Insights' },

  // devices
  { id: 'devices', path: '/devices', authRequired: true, label: 'Devices' },
  { id: 'device-detail', path: '/device-detail/:deviceId', authRequired: true, parent: 'devices', label: 'Device Detail' },

  // vendors
  { id: 'vendors', path: '/vendors', authRequired: true, label: 'Vendors' },
  { id: 'vendor-add', path: '/add-vendor', authRequired: true, parent: 'vendors', label: 'Add Vendor' },
  { id: 'vendor-detail', path: '/vendor-detail/:vendorId', authRequired: true, parent: 'vendors', label: 'Vendor Detail' },
  { id: 'vendor-update', path: '/vendor-update/:vendorId/:activeTab', authRequired: true, parent: 'vendor-detail', label: 'Vendor Update' },

  // integrations
  { id: 'integrations', path: '/integrations', authRequired: true, label: 'Integrations' },

  // licenses
  { id: 'licenses', path: '/licenses', authRequired: true, label: 'Licenses' },
  { id: 'license-add', path: '/add-license', authRequired: true, parent: 'licenses', label: 'Add License' },
  { id: 'license-detail', path: '/license-detail/:licenseId', authRequired: true, parent: 'licenses', label: 'License Detail' },
  { id: 'license-update', path: '/license-update/:licenseId/:activeTab', authRequired: true, parent: 'license-detail', label: 'License Update' },
];
